import { render, staticRenderFns } from "./SeparatorLine.vue?vue&type=template&id=05fc5f69&scoped=true&"
import script from "./SeparatorLine.vue?vue&type=script&lang=js&"
export * from "./SeparatorLine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fc5f69",
  null
  
)

export default component.exports